import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Admin from '@/components/Admin'
import About from '@/components/About'

import Cupcake from '@/components/portfolio/work/Cupcake'
import Walkers from '@/components/portfolio/work/Walkers'
import Bebe from '@/components/portfolio/work/Bebe'
import Wimble from '@/components/portfolio/work/Wimble'
import Timjam from '@/components/portfolio/work/Timjam'
import Mai from '@/components/portfolio/work/Mai'
import Em from '@/components/portfolio/work/Em_basket'
import Small from '@/components/portfolio/work/Small'
import Selma from '@/components/portfolio/work/Selma'
import Oe from '@/components/portfolio/work/Oe'
import Bug from '@/components/portfolio/work/Bug'
import Pitko from '@/components/portfolio/work/Pitko'
import Peach from '@/components/portfolio/work/Peach'
import Toast from '@/components/portfolio/work/Toast'
import Revolve from '@/components/portfolio/work/Revolve'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/wimble',
      name: 'wimble',
      component: Wimble
    },
    {
      path: '/walkers',
      name: 'walkers',
      component: Walkers
    },
    {
      path: '/bebe',
      name: 'bebe',
      component: Bebe
    },
    {
      path: '/cupcake',
      name: 'cupcake',
      component: Cupcake
    },
    {
      path: '/timjam',
      name: 'timjam',
      component: Timjam
    },
    {
      path: '/mai',
      name: 'mai',
      component: Mai
    },
    {
      path: '/em',
      name: 'em',
      component: Em
    },
    {
      path: '/small',
      name: 'small',
      component: Small
    },
    {
      path: '/selma',
      name: 'selma',
      component: Selma
    },
    {
      path: '/bug',
      name: 'bug',
      component: Bug
    },
    {
      path: '/oe',
      name: 'oe',
      component: Oe
    },
    {
      path: '/toast',
      name: 'toast',
      component: Toast
    },
    {
      path: '/pitko',
      name: 'pitko',
      component: Pitko
    },
    {
      path: '/peach',
      name: 'peach',
      component: Peach
    },
    {
      path: '/revolve',
      name: 'revolve',
      component: Revolve
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js